import { render, staticRenderFns } from "./CommonCRM.vue?vue&type=template&id=3ef43803&"
import script from "./CommonCRM.vue?vue&type=script&lang=js&"
export * from "./CommonCRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports